<template>
    <v-container>
        <!-- Email Pills Input -->
        <v-text-field v-model="emailInput"
                      label="Enter email and press enter"
                      @keyup.enter="addEmail"
                      append-outer-icon="mdi-email-plus"
                      @click:append-outer="addEmail"></v-text-field>
        <v-chip-group v-model="emails" multiple column>
            <v-chip v-for="(email, index) in emails"
                    :key="index"
                    close
                    @click:close="removeEmail(index)">
                {{ email }}
            </v-chip>
        </v-chip-group>

        <!-- Unlayer Editor -->
        <v-card>
            <v-card-text>
                <!--<div id="editor" style="height: 500px"></div>-->
                
                        <div id="gjs"></div>
                    
            </v-card-text>
        </v-card>

        <!-- Share Button -->
        <v-btn color="primary" @click="shareMessage">Share</v-btn>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { ref, onMounted } from 'vue'
    import grapesjs from 'grapesjs'
    import 'grapesjs/dist/css/grapes.min.css'
    import plugin from 'grapesjs-preset-newsletter'
    import EmailTemplatesService from '@/services/EmailTemplatesService.js'
    import juice from 'juice'
    export default {
        data() {
            return {
                emailInput: '',
                emails: [],
                htmlContent: '',
                templateObj: {},
                designJson: {},
                editor:null
            }
        },
        computed: {
            ...mapGetters('user', ['language']),
            getLanguage() {
                return this.language == null ? 'ar' : this.language

            },
        },
        methods: {
            addEmail() {
                if (this.emailInput && !this.emails.includes(this.emailInput)) {
                    this.emails.push(this.emailInput)
                    this.emailInput = ''
                }
            },
            removeEmail(index) {
                this.emails.splice(index, 1)
            },
            async shareMessage() {
                const html = this.editor.getHtml()

                // Get the CSS styles
                const css = this.editor.getCss()

                // Combine HTML and CSS into one string if needed
                const fullHtml = `
  <html>
    <head>
      <style>${css}</style>
    </head>
    <body>
      ${html}
    </body>
  </html>
`
                this.htmlContent = juice(fullHtml)
                try {
                    var response = await EmailTemplatesService.shareSurvey(this.emails, this.htmlContent)
                    if (response.success) {
                        alert('Message sent successfully')
                    }
                    else {
                        alert('Failed to send message')
                    }

                } catch (error) {
                    console.log('ERROR', error)
                    alert('Error sending message')
                }
            },
            async initUnlayer() {
                /*unlayer.init({
                    id: 'editor',
                    displayMode: 'email',
                    locale: this.language == null ? 'ar' : this.language
                    // Add any additional configuration options here
                })
                this.templateObj = await EmailTemplatesService.getShareSurveyTemplate(this.$route.query.id)
                this.htmlContent = this.templateObj.data.body
                console.log(this.templateObj)
                unlayer.loadDesign(JSON.parse(this.templateObj.data.designJson))
                unlayer.addEventListener('design:updated', () => {
                    unlayer.exportHtml((data) => {
                        this.htmlContent = data.html
                        this.designJson = data.design
                    })
                })*/
            },
        },
        async mounted() {
            /*const script = document.createElement('script')
            script.src = 'https://editor.unlayer.com/embed.js'
            script.onload = this.initUnlayer
            document.body.appendChild(script)*/
            this.templateObj = await EmailTemplatesService.getShareSurveyTemplate(this.$route.query.id)
            this.htmlContent = this.templateObj.data.body
            this.editor = grapesjs.init({
                container: '#gjs',
                plugins: [plugin],
                pluginsOpts: {
                    [plugin]: { /* options */ }
                },
                storageManager: false,
  
            }),
                
            this.editor.setComponents(this.htmlContent)
        },
    }
</script>

<style>
    /* Add any custom styles here */
    .brand {
        display: none !important
    }
    #blocks {
        margin-bottom: 10px;
    }
</style>
